module.exports = "https://dev.stanwinstonschool.com/ai_artificialintelligence_poster_org.0f5d311e73ffd99e075cc45837630f3f.jpg";